import type { Translations } from '../../types'

const supportMessages: Translations = {
  "support.inbox.header.eyebrow": "Assistenza",
  "support.inbox.header.title": "Inbox assistenza clienti",
  "support.inbox.header.subtitle": "Monitora le richieste clienti e il loro stato. Le conversazioni vengono gestite principalmente via email.",
  "support.inbox.auth.title": "Sessione non disponibile",
  "support.inbox.auth.subtitle": "Effettua il login per gestire le richieste assistenza.",
  "support.inbox.auth.missingToken": "Token amministratore mancante.",
  "support.inbox.filters.search": "Ricerca",
  "support.inbox.filters.searchPlaceholder": "Cerca per cliente, oggetto, ordine o email esatta",
  "support.inbox.filters.title": "Filtro inbox",
  "support.inbox.filters.subtitle": "Consulta la coda ticket per stato, priorita e intervallo temporale.",
  "support.inbox.filters.anyDate": "Seleziona data",
  "support.inbox.filters.status": "Stato ticket",
  "support.inbox.filters.priority": "Priorita",
  "support.inbox.filters.createdFrom": "Aperto dal",
  "support.inbox.filters.createdTo": "Aperto al",
  "support.inbox.filters.actions": "Azioni",
  "support.inbox.status.all": "Tutti gli stati",
  "support.inbox.status.open": "Aperto",
  "support.inbox.status.inProgress": "In lavorazione",
  "support.inbox.status.resolved": "Risolto",
  "support.inbox.status.closed": "Chiuso",
  "support.inbox.priority.all": "Tutte le priorita",
  "support.inbox.priority.low": "Bassa",
  "support.inbox.priority.medium": "Media",
  "support.inbox.priority.high": "Alta",
  "support.inbox.priority.urgent": "Urgente",
  "support.inbox.actions.apply": "Applica",
  "support.inbox.actions.reset": "Reset",
  "support.inbox.actions.replyEmail": "Rispondi via email",
  "support.inbox.actions.save": "Salva aggiornamenti",
  "support.inbox.actions.saving": "Salvataggio...",
  "support.inbox.actions.refreshList": "Aggiorna lista",
  "support.inbox.actions.newRequest": "Nuova richiesta assistenza",
  "support.inbox.actions.newTicket": "Nuovo ticket",
  "support.inbox.overview.open": "Ticket aperti",
  "support.inbox.overview.highPriority": "Alta priorita",
  "support.inbox.overview.recentActivity": "Attivi ultime 24h",
  "support.inbox.list.title": "Lista ticket",
  "support.inbox.list.resultsSummary": "{{total}} risultati • Pagina {{page}} / {{totalPages}}",
  "support.inbox.list.updating": "Aggiornamento...",
  "support.inbox.list.columns.ticket": "Ticket",
  "support.inbox.list.columns.customer": "Cliente",
  "support.inbox.list.columns.order": "Ordine collegato",
  "support.inbox.list.columns.status": "Stato",
  "support.inbox.list.columns.priority": "Priorita",
  "support.inbox.list.columns.lastActivity": "Ultima attivita",
  "support.inbox.list.columns.channel": "Canale",
  "support.inbox.list.channelEmail": "Email",
  "support.inbox.list.empty": "Nessun ticket per i filtri correnti.",
  "support.inbox.list.emptyTitle": "Nessun ticket trovato",
  "support.inbox.list.emptyDescription": "Non ci sono richieste in coda al momento. Attendi nuove richieste clienti.",
  "support.inbox.list.emptyDescriptionFiltered": "Prova a modificare i filtri correnti oppure attendi nuove richieste clienti.",
  "support.inbox.list.noOrder": "Ordine non associato",
  "support.inbox.list.prevPage": "Pagina precedente",
  "support.inbox.list.nextPage": "Pagina successiva",
  "support.inbox.detail.selectPrompt": "Seleziona un ticket dalla lista per vedere il dettaglio.",
  "support.inbox.detail.loading": "Caricamento dettaglio ticket...",
  "support.inbox.detail.customer": "Cliente",
  "support.inbox.detail.email": "Email",
  "support.inbox.detail.emailUnavailable": "Email non disponibile",
  "support.inbox.detail.backToList": "Torna alla lista ticket",
  "support.inbox.detail.userId": "User ID: {{id}}",
  "support.inbox.detail.subject": "Oggetto",
  "support.inbox.detail.order": "Ordine",
  "support.inbox.detail.created": "Creato",
  "support.inbox.detail.assignee": "Assegnatario",
  "support.inbox.detail.unassigned": "Non assegnato",
  "support.inbox.detail.internalNotes": "Note interne",
  "support.inbox.detail.internalNotesPlaceholder": "Annotazioni interne per il team support...",
  "support.inbox.detail.loadError": "Impossibile caricare il ticket selezionato.",
  "support.inbox.timeline.title": "Timeline eventi",
  "support.inbox.timeline.empty": "Nessun evento disponibile.",
  "support.inbox.timeline.operator": "Operatore: {{operator}}",
  "support.inbox.messages.loadListError": "Errore caricamento ticket assistenza",
  "support.inbox.messages.loadDetailError": "Errore caricamento dettaglio ticket",
  "support.inbox.messages.saveSuccess": "Ticket aggiornato",
  "support.inbox.messages.saveError": "Salvataggio ticket fallito",
  "support.inbox.customerComposer.title": "Apri un nuovo ticket",
  "support.inbox.customerComposer.subtitle": "Descrivi il problema e, se disponibile, collega l'ID ordine.",
  "support.inbox.customerComposer.subject": "Oggetto",
  "support.inbox.customerComposer.subjectPlaceholder": "Es. Problema con ordine",
  "support.inbox.customerComposer.orderId": "ID ordine (opzionale)",
  "support.inbox.customerComposer.orderIdPlaceholder": "Es. 67dc0b0ea9f8a1f6a9f44abc",
  "support.inbox.customerComposer.orderSearchPlaceholder": "Cerca ordine per numero",
  "support.inbox.customerComposer.orderNotLinked": "Nessun ordine collegato",
  "support.inbox.customerComposer.orderSearchEmpty": "Nessun ordine trovato per la ricerca corrente.",
  "support.inbox.customerComposer.message": "Messaggio",
  "support.inbox.customerComposer.messagePlaceholder": "Spiega il problema in dettaglio...",
  "support.inbox.customerComposer.submit": "Apri ticket",
  "support.inbox.customerComposer.submitting": "Invio..."
}

export default supportMessages
